<script>
export default {
  name: 'loading'
}
</script>
<template>
  <div>
    <!-- Begin page -->
    <div id="layout-wrapper">
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <slot />
          </div>
          <!-- container-fluid -->
        </div>
      </div>
      <!-- end main content-->
    </div>
    <!-- END layout-wrapper -->
  </div>
</template>
